export default __webpack_public_path__ + "static/media/welcome-cafgu.a4d11aec.svg";